module.exports = __webpack_public_path__ + "img/Michael Bolin.8a8bced2.jpg";